// extracted by mini-css-extract-plugin
module.exports = {"window":"_3GH9-KPOuQWUPwxkNEKSLi"};